import { module } from 'modujs';
import { Swiper, Navigation, Lazy, Mousewheel, Scrollbar } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                filter: 'filter'
            }
        }
    }

    init() {

        this.slides = Array.from(this.$('carousel-item')).map((item) => {
            return {
                ids: item.getAttribute('data-id').split(','),
                el: item.outerHTML
            }
        })

        this.currentSlides = []

        Swiper.use([Navigation, Lazy, Mousewheel, Scrollbar]);
        this.carousel = this.$('carousel')[0];
        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]
        this.scrollbar = this.$('scrollbar')[0]

        this.carousel = new Swiper(this.carousel, {
            speed: 600,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1.2,
            spaceBetween: 0,
            threshold: 10,
            preloadImages: false,
            loadPrevNext: true,
            watchSlidesVisibility: true,
            lazy: true,
            preventClicks: true,
            preventClicksPropagation: true,
            preventInteractionOnTransition: true,
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            },
            mousewheel: true,
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
            },
            breakpoints: {
                700: {
                    freeMode: true,
                    slidesPerView: 2.5,
                },
                1000: {
                    freeMode: true,
                    slidesPerView: 2.5,
                }
            }
        });
    }

    filter(e) {
        let id = e.curTarget.getAttribute('data-filter-id')

        this.$('filter').forEach((item) => {
            item.classList.remove('is-active')
        })

        e.curTarget.classList.add('is-active')

        if(id == "all") {
            this.currentSlides = this.slides.map((item) => {
                return item.el
            })
        } else {
            this.currentSlides = this.slides.map((item) => {

                if(item.ids.includes(id)) {
                    return item.el
                }
            })
        }

        this.$('carousel')[0].classList.remove('is-show')

        setTimeout(() => {
            this.carousel.removeAllSlides();
            this.carousel.appendSlide(this.currentSlides)
            this.carousel.lazy.load()
            this.carousel.scrollbar.updateSize()

            this.$('carousel')[0].classList.add('is-show')
        }, 500);
    }

    slideToFirst() {
        this.carousel.slideTo(0,0)
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy()
    }
}
